var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2F40E468-92C7-4A44-BA3F-9EC855631386") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat_security-Copy",
    transform: "translate(-328.000000, -183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list/sidebar_security",
    transform: "translate(15.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-1",
    transform: "translate(10.000000, 105.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "good-alert",
    transform: "translate(303.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_close",
    fill: "#00FF44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 10,
    cy: 10,
    r: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.46051563,14.6884498 C8.02403676,15.1038501 7.31735668,15.1038501 6.88087781,14.6884498 C6.88087781,14.6884498 3.30481406,11.2678084 3.29387474,11.2575516 C2.89130776,10.8370229 2.90224708,10.1857164 3.32723967,9.77544455 C3.76317157,9.36004431 4.47039862,9.36004431 4.90687749,9.77544455 L7.67014975,12.4216979 L14.57651,5.9633083 C15.012442,5.54790806 15.719669,5.54790806 16.1561479,5.9633083 C16.5920798,6.37870853 16.5920798,7.05565707 16.1561479,7.4761857 C16.1561479,7.4761857 8.60710252,14.5448547 8.46051563,14.6884498 Z",
    id: "Fill-34",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodAlert);
export default __webpack_public_path__ + "static/media/good-alert.6a94cff833c17863566da7d92a54526e.svg";
export { ForwardRef as ReactComponent };